module.exports = __webpack_public_path__ + "img/3dcart.4b6a1a9d.svg";